import React from "react";

// External
import styled from "styled-components";

// Internal
import { breakpoints, fontFamily, colors } from "../../../theme";
import { PageSection } from "../../components/layout/layout-styles";

// Assets
import earthPlane from "../../images/earth-plane.svg";
import SplashText from "../../components/SplashText";

// Styles
const Section = styled(PageSection)`
  margin: 0 auto;
  width: 94%;
  max-width: 1040px;
  display: grid;
  gap: 28px;
`;

const ContentGrid = styled.div`
  display: grid;
  column-gap: 88px;
  row-gap: 48px;
  grid-template-areas:
    "sec2"
    "sec1"
    "sec3";

  @media only screen and (min-width: ${breakpoints.desktop}) {
    grid-template-areas:
      "sec1 sec2"
      "sec1 sec3";
  }
`;

const Illustration = styled.div`
  grid-area: sec1;
  width: 302px;
  margin: 0 auto;
  display: flex;

  @media only screen and (min-width: 1100px) {
    width: 404px;
    margin: 0;
  }

  img {
    width: 100%;
    height: auto;
    margin: auto 0;
  }
`;

const TextSection = styled.div`
  grid-area: sec2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    align-items: flex-start;
    text-align: start;
  }
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${fontFamily.bold};
  font-size: 32px;
  line-height: 102%;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 40px;
  }
`;

const Description = styled.span`
  display: block;
  margin: 0;
  font-size: 16px;
  line-height: 108%;
  font-weight: 500;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 20px;
  }
`;

const StatsRow = styled.div`
  grid-area: sec3;
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 323px;
  height: 118px;
  margin: 0 auto;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    width: 548px;
    height: 130px;
    margin: 0;
  }
`;

const StatCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-top: 20px;
  border-radius: 12px;
  border: 2px solid ${colors.linkHover.dark};
`;

const StatValue = styled.span`
  font-family: ${fontFamily.bold};
  font-size: 32px;
  line-height: 108%;
  color: ${colors.linkHover.light};

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 40px;
  }
`;

const StatLabel = styled.span`
  width: 100px;
  text-align: center;
  font-size: 14px;
  line-height: 108%;
  font-weight: 500;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    width: 125px;
    font-size: 16px;
  }
`;

const UnlockingSuccessSection = () => {
  return (
    <Section name="unlocking-success" as="section">
      <ContentGrid>
        <Illustration>
          <img
            src={earthPlane}
            alt="earth icon"
            width={1545}
            height={1292}
            loading="lazy"
            decoding="async"
          />
        </Illustration>

        <TextSection>
          <Heading>
            Helping startups turn{" "}
            <SplashText variant="accent">ideas</SplashText> into{" "}
            <SplashText variant="accent">products</SplashText>
          </Heading>
          <Description>
            Founders across the globe trust me to ship fast, scalable
            front-ends, I got you covered from prototype till production.
          </Description>
        </TextSection>

        <StatsRow>
          <StatCard>
            <StatValue>7+</StatValue>
            <StatLabel>Years of experience</StatLabel>
          </StatCard>

          <StatCard>
            <StatValue>20+</StatValue>
            <StatLabel>Startup partnerships</StatLabel>
          </StatCard>

          <StatCard>
            <StatValue>80+</StatValue>
            <StatLabel>Projects shipped</StatLabel>
          </StatCard>
        </StatsRow>
      </ContentGrid>
    </Section>
  );
};

export default UnlockingSuccessSection;
